module.exports = __webpack_public_path__ + "resources/img/img_credit_event3_v2.39656c5f8ffbd9a63852ecd19e82c211.png";